export default __webpack_public_path__ + "static/media/UK02.bfda16c5.mp3";